import Enum from '@square/dashboard-utilities/utils/enum';
export default new Enum('FULL_REFUND', 'PARTIAL_REFUND', 'ITEMIZED_REFUND');